import { render, staticRenderFns } from "./URegisterEmailEdit.vue?vue&type=template&id=34db4106&scoped=true&"
import script from "./URegisterEmailEdit.vue?vue&type=script&lang=ts&"
export * from "./URegisterEmailEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34db4106",
  null
  
)

export default component.exports